import React, { Component } from "react";
import { FiCast, FiLayers, FiUsers, FiMonitor } from "react-icons/fi";

const ServiceList = [
  {
    icon: <FiCast />,
    title: "עשרות שנות ניסיון",
    description:
      "לחברה ניסיון רב במתן שירותי סיעוד והיא מתמחה במתן פתרונות סיעודיים למקרים המורכבים ביותר",
  },
  {
    icon: <FiLayers />,
    title: "רשת סניפים בפרישה ארצית",
    description:
      "ארזים נותנת שירות לקשישים ברשויות מקומיות רבות ברחבי הארץ ולרשותה מערך סניפים בפריסה ארצית.",
  },
  {
    icon: <FiUsers />,
    title: "מענה למקרים מורכבים",
    description:
      "עובדי ארזים הוכשרו להעניק טיפול למקרים סיעודיים מורכבים וקשים כולל אנשים המרותקים למיטה.",
  },
  {
    icon: <FiMonitor />,
    title: "צוות מקצועי איכותי ונרחב",
    description:
      "לארזים צוות מקצועי של אחיות, עובדות סוציאליות וגרנטולוגיות, הנדרשות לעמוד בסטנדרטים הגבוהים ביותר.",
  },
  {
    icon: <FiUsers />,
    title: "התאמה מיטבית",
    description:
      "ארזים דואגת להתאים למטופל מטפל העונה על הצרכים והדרישות הייחודיים לו, לרבות שפתו ומנהגיו.",
  },
  {
    icon: <FiMonitor />,
    title: "תקני איכות מחמירים",
    description:
      "החברה עומדת בתקן האיכות המחמיר  ISO 9001:2008 עבור מתן שירותי סיעוד וכוח אדם סיעודי.",
  },
];

class ServiceThree extends Component {
  render() {
    const { column } = this.props;
    const ServiceContent = ServiceList.slice(0, this.props.item);

    return (
      <React.Fragment>
        <div className="row">
          {ServiceContent.map((val, i) => (
            <div className={`${column}`} key={i}>
              <a href="/about">
                <div className="service service__style--2">
                  <div className="icon">{val.icon}</div>
                  <div className="content">
                    <h3 className="title">{val.title}</h3>
                    <p>{val.description}</p>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}
export default ServiceThree;
